import React from "react";

const PortalLayout = ({ children }) => {
  return <>{children}</>;
};

export default PortalLayout;